var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeal = function SvgDeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.56481L2.60002 4.58297V9.34784C2.55736 11.1484 4.64485 12.7612 6.59901 14.4167",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77987 8.04863L7.66683 9.98146C7.7859 10.1037 7.92787 10.2012 8.08465 10.2686C8.24142 10.336 8.40993 10.3718 8.58054 10.374C8.75116 10.3762 8.92054 10.3448 9.07902 10.2816C9.2375 10.2184 9.38197 10.1245 9.50419 10.0055C9.62641 9.88639 9.72398 9.74442 9.79133 9.58765C9.85868 9.43087 9.89449 9.26237 9.89672 9.09175C9.89895 8.92114 9.86755 8.75175 9.80432 8.59327C9.74109 8.43479 9.64726 8.29032 9.52819 8.1681L6.59375 5.17393V3.61337C6.43477 2.67827 6.07921 1.78753 5.55054 1",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59985 8.88064V21.8003C6.59985 22.2246 6.76843 22.6316 7.06849 22.9317C7.36855 23.2317 7.77552 23.4003 8.19988 23.4003H16.2",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.4345L23.4 21.4163V16.6525C23.4373 15.0962 21.8843 13.6807 20.2 12.2578V17.9304L18.3333 16.0189C18.0928 15.7721 17.7641 15.6309 17.4196 15.6264C17.075 15.6219 16.7427 15.7544 16.4959 15.9949C16.2491 16.2354 16.1079 16.564 16.1034 16.9086C16.0989 17.2532 16.2314 17.5854 16.4719 17.8323L19.4106 20.8275V22.387C19.5704 23.3205 19.9259 24.2097 20.4538 24.9961",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0431 19.4003H9.7998",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3998 15.4002H9.7998",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8003 5.80007C21.8003 6.74943 21.5188 7.67748 20.9914 8.46684C20.4639 9.25621 19.7143 9.87145 18.8372 10.2348C17.9601 10.5981 16.9949 10.6931 16.0638 10.5079C15.1327 10.3227 14.2774 9.86553 13.6061 9.19423C12.9348 8.52293 12.4776 7.66764 12.2924 6.73652C12.1072 5.80539 12.2023 4.84026 12.5656 3.96316C12.9289 3.08606 13.5441 2.3364 14.3335 1.80896C15.1229 1.28152 16.0509 1 17.0003 1",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8004 2.19899L17.427 6.57239C17.3711 6.62863 17.3046 6.67327 17.2314 6.70373C17.1582 6.73419 17.0797 6.74987 17.0004 6.74987C16.921 6.74987 16.8425 6.73419 16.7693 6.70373C16.6961 6.67327 16.6296 6.62863 16.5737 6.57239L15.1987 5.19637",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDeal;